/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  PostApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidMutationRequest,
  PostApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidMutationResponse,
  PostApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidPathParams,
  PostApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid400,
  PostApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid401,
  PostApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid404,
  PostApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid500,
} from "../../types/classPlanningGradeAndFrequenceConfigurationController/PostApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid.ts";

function getPostApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidUrl(
  classModuleId: PostApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidPathParams["classModuleId"],
) {
  const res = {
    method: "POST",
    url: `/api/v1/classroomdiscipline/grade-and-frequence/class-modules/${classModuleId}` as const,
  };
  return res;
}

/**
 * @description Vincula as Aulas informadas ao Módulo (aditivo). Aula já vinculada a outro Módulo é realocada. **(Requer Authorization para autenticação)**
 * @summary Anexar Aulas ao Módulo (Requer Authorization para autenticação)
 * {@link /api/v1/classroomdiscipline/grade-and-frequence/class-modules/:classModuleId}
 */
export async function postApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid(
  classModuleId: PostApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidPathParams["classModuleId"],
  data?: PostApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidMutationRequest,
  config: Partial<
    RequestConfig<PostApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidMutationRequest>
  > & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidMutationResponse,
    ResponseErrorConfig<
      | PostApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid400
      | PostApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid401
      | PostApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid404
      | PostApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid500
    >,
    PostApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidMutationRequest
  >({
    method: "POST",
    url: getPostApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidUrl(
      classModuleId,
    ).url.toString(),
    data: requestData,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res.data;
}
